export const getStatusColor = (status: string) => {
  switch (status) {
    case 'directeur':
      return 'bg-purple-100 text-purple-800';
    case 'expert':
      return 'bg-red-100 text-red-800';
    case 'senior':
      return 'bg-orange-100 text-orange-800';
    case 'confirmé':
      return 'bg-yellow-100 text-yellow-800';
    case 'animateur':
      return 'bg-indigo-100 text-indigo-800';
    case 'direction':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};

export const getStatusBadgeClass = (status: string) => {
  switch (status) {
    case 'directeur':  return 'bg-purple-50 text-purple-700 border-purple-200';
    case 'expert':     return 'bg-red-50 text-red-700 border-red-200';
    case 'senior':     return 'bg-orange-50 text-orange-700 border-orange-200';
    case 'confirmé':   return 'bg-yellow-50 text-yellow-700 border-yellow-200';
    case 'animateur':  return 'bg-indigo-50 text-indigo-700 border-indigo-200';
    case 'conseiller': return 'bg-teal-50 text-teal-700 border-teal-200';
    case 'direction':  return 'bg-amber-50 text-amber-700 border-amber-200';
    default:           return 'bg-slate-50 text-slate-700 border-slate-200';
  }
};

export const getCompletionColor = (rate: number) => {
  if (rate >= 100) return 'text-green-600';
  if (rate >= 75) return 'text-blue-600';
  if (rate >= 50) return 'text-yellow-600';
  return 'text-red-600';
};

export const getMedalColor = (index: number) => {
  switch (index) {
    case 0:
      return 'text-yellow-400'; // Or
    case 1:
      return 'text-gray-400'; // Argent
    case 2:
      return 'text-amber-600'; // Bronze
    default:
      return 'text-gray-300';
  }
};